export const ROUTE_PATHS = {
  LANDING_PAGE: "/",
  CONTACT_US_PAGE: "/contact-us",
  PRIVACY_PAGE: "/privacy",
  TERMS_PAGE: "/terms",
  REPORT_PAGE: "/report",
  HOME_CHARGIN_PAGE: "/home-charging",
};
